export default __webpack_public_path__ + "static/media/manor3.609d52e1.svg";